import { encryptGPS, decryptGPS, getBaseGPS } from '../util/location'

/**
 *  @author Claude Xin
 */

/**
 *
 * @param { int } imgLongSideSize Image long side size
 * @param { * } handleImage take photo successfully and handle it
 * @param { * } handleError error occur
 */
function obtainImage(imgLongSideSize, handleImage, handleError) {
  // configure the camera
  var options = {
    quality: 100,
    destinationType: window.Camera.DestinationType.DATA_URL,
    sourceType: window.Camera.PictureSourceType.CAMERA,
    encodingType: window.Camera.EncodingType.JPEG,
    mediaType: window.Camera.MediaType.PICTURE,
    allowEdit: true,
    correctOrientation: true
  }

  navigator.camera.getPicture(
    img => {
      resizeImage(imgLongSideSize, img, handleImage)
    },
    handleError,
    options
  )
}

function selectImage(imgLongSideSize, handleImage, handleError) {
  // configure the camera
  var options = {
    quality: 100,
    destinationType: window.Camera.DestinationType.DATA_URL,
    sourceType: window.Camera.PictureSourceType.PHOTOLIBRARY,
    encodingType: window.Camera.EncodingType.JPEG,
    mediaType: window.Camera.MediaType.PICTURE,
    allowEdit: true,
    correctOrientation: true
  }

  navigator.camera.getPicture(
    img => {
      resizeImage(imgLongSideSize, img, handleImage)
    },
    handleError,
    options
  )
}

/**
 *
 * @param { * } longSideMax Image long side size
 * @param { * } base64url Image base64 coding
 * @param { * } callback Used to return successful image
 */
function resizeImage(longSideMax, base64url, callback) {
  var tmpImage = new Image()
  var lon = ''
  var lat = ''
  getBaseGPS(navigator)
    .then(
      position => {
        lon = position.longitude
        lat = position.latitude
      }).then(() => {
        tmpImage.onload = function () {
          var targetWidth = tmpImage.width
          var targetLength = tmpImage.height
          var aspect = targetWidth / targetLength

          if (tmpImage.width > tmpImage.height) {
            longSideMax = Math.min(tmpImage.width, longSideMax)
            targetWidth = longSideMax
            targetLength = longSideMax / aspect
          } else {
            longSideMax = Math.min(tmpImage.height, longSideMax)
            targetLength = longSideMax
            targetWidth = targetLength * aspect
          }

          var canvas = document.createElement('canvas')
          canvas.width = targetWidth
          canvas.height = targetLength

          var ctx = canvas.getContext('2d')
          ctx.drawImage(this, 0, 0, tmpImage.width, tmpImage.height, 0, 0, targetWidth, targetLength)
          ctx.fillStyle = '#ffffff'
          ctx.font = '40px microsoft yahei'
          let date = new Date()
          ctx.fillText(lon + '|' + lat, 250, targetLength - 80)
          ctx.fillText(dateFormat('YYYY-mm-dd HH:MM', date), targetWidth - 450, targetLength - 20)
          callback(canvas.toDataURL('image/jpeg'))
        }
        tmpImage.src = 'data:image/jpeg;base64,' + base64url
      }).catch(() => {
        tmpImage.onload = function () {
          var targetWidth = tmpImage.width
          var targetLength = tmpImage.height
          var aspect = targetWidth / targetLength

          if (tmpImage.width > tmpImage.height) {
            longSideMax = Math.min(tmpImage.width, longSideMax)
            targetWidth = longSideMax
            targetLength = longSideMax / aspect
          } else {
            longSideMax = Math.min(tmpImage.height, longSideMax)
            targetLength = longSideMax
            targetWidth = targetLength * aspect
          }

          var canvas = document.createElement('canvas')
          canvas.width = targetWidth
          canvas.height = targetLength

          var ctx = canvas.getContext('2d')
          ctx.drawImage(this, 0, 0, tmpImage.width, tmpImage.height, 0, 0, targetWidth, targetLength)
          ctx.fillStyle = '#ffffff'
          ctx.font = '40px microsoft yahei'
          let date = new Date()
          ctx.fillText(dateFormat('YYYY-mm-dd HH:MM', date), targetWidth - 300, targetLength - 20)
          callback(canvas.toDataURL('image/jpeg'))
        }
        tmpImage.src = 'data:image/jpeg;base64,' + base64url
      })

}

function dateFormat(fmt, date) {
  let ret
  const opt = {
    'Y+': date.getFullYear().toString(),        // 年
    'm+': (date.getMonth() + 1).toString(),     // 月
    'd+': date.getDate().toString(),            // 日
    'H+': date.getHours().toString(),           // 时
    'M+': date.getMinutes().toString(),         // 分
    'S+': date.getSeconds().toString()          // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }
  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
    }

  }

  return fmt
}

/**
 * demo:
 *
 * obtainImage(300, img => {
 *     this.imgSrc = img;
 *   },
 *   error => {
 *     alert(error);
 *   }
 * );
 *
 */

export { obtainImage, selectImage, resizeImage }
